var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectsLite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33338 3.16667V1.83333H6.66671V3.16667H9.33338ZM1.33338 4.5V15.1667H14.6667V4.5H1.33338ZM14.4 3.16667C15.288 3.16667 16 4.30982 16 5.16667V14.9561C16 15.813 15.288 16.5 14.4 16.5H1.60004C0.712043 16.5 4.32872e-05 15.813 4.32872e-05 14.9561V5.16667C-0.00802006 3.86842 1.11204 3.16667 2.00004 3.16667H5.33338C5.33338 2.30982 5.51204 0.5 6.40004 0.5H9.60004C10.488 0.5 10.6667 2.30982 10.6667 3.16667H14.4Z",
    fill: "#5B79B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsLite);
export default __webpack_public_path__ + "static/media/projects_lite.511f48ff.svg";
export { ForwardRef as ReactComponent };